import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

type ControlledCheckboxNewProps = {
  name: string;
  label?: string;
  customizedLabel?: React.ReactNode;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  defaultValue?: boolean;
};

export const ControlledCheckboxNew = (props: ControlledCheckboxNewProps) => {
  const { name, label, customizedLabel, labelPlacement = 'end', defaultValue = false } = props;

  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => (
        <FormControlLabel
          label={customizedLabel ?? label}
          labelPlacement={labelPlacement}
          control={<Checkbox checked={!!value} onChange={(_, checked) => onChange(checked)} />}
        />
      )}
    />
  );
};
